import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import React from 'react';
import useRect from 'hooks/common/useRect';
import { Chart, layouts } from 'chart.js';

const labels = Array.from({ length: 4 * 24 + 1 }).map((_, index) => `${Math.floor(index / 4).toString().padStart(2, '0')}${((index % 4) * 15).toString().padStart(2, '0')}`);
const config = (hash) => ({
  type: 'line',
  data: {
    labels,
    datasets: [
      {
        pointRadius: 0,
        borderColor: '#808080',
        data: hash.values.map((value, index) => {
          // return Math.random() * 250;
          return +value || NaN;
        }),
        // }, {
        //   data: hash.values.map(() => 70),
        //   fill: '-1',
        //   backgroundColor: '#80008010',
        //   pointRadius: 0,
        //   borderWidth: 0,
        // }, {
        //   pointRadius: 0,
        //   borderWidth: 0,
        //   data: hash.values.map(() => 180),
        //   fill: '-2',
        //   backgroundColor: '#ffffff10',
      }
    ]
  },
  options: {
    layout: {
      padding: {
        left: 42,
        right: 13.4,
        top: 0,
        bottom: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      intersect: false,
    },
    scales: {
      x: {
        ticks: {
          font: {
            family: 'Pretendard',
            weight: 400,
            size: 11,
            color: '#aaaaaa',
          },
          callback: (value) => {
            if (value % 24 !== 0) return null;
            if (/\d\d00$/.test(labels[value])) {
              return '';
            } else {
              return null;
            }
          },
        },
        title: {
          display: false,
        },
        grid: {
          drawTicks: false,
        },
      },
      y: {
        min: 0,
        max: hash.max + 10,
        ticks: {
          align: 'start',
          stepSize: 1,
          callback: (value, index, values) => {
            switch (value) {
              case 70:
              case 180:
                return value;
              case hash.max + 10:
                return T('(혈당)');
              default: return null;
            }
          },
        },
        title: {
          display: false,
        },
        grid: {
          // display: false,
          drawTicks: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          title: function (context) {
            const label = (context[0].label || '').split('');
            label.splice(2, 0, ':');
            return label.join('');
          }
        },
      },
    },
  },
  plugins: [{
    afterDatasetDraw: (chart, args, options) => {
      let ctx = chart.ctx;
      const xAxis = chart.scales.x;
      const yAxis = chart.scales.y;
      if (!xAxis) return;
      if (!yAxis) return;

      const zero = yAxis.getPixelForValue(0);
      const low = yAxis.getPixelForValue(70);
      const high = yAxis.getPixelForValue(180);

      ctx.save();
      ctx.globalAlpha = 0.1;
      ctx.fillStyle = '#000000';
      ctx.fillRect(xAxis.left, high, xAxis.right - xAxis.left, high + 15);
      ctx.restore();

      ctx.save();
      ctx.globalCompositeOperation = 'source-atop';

      ctx.globalAlpha = 0.5;
      ctx.fillStyle = '#F61848';
      ctx.fillRect(xAxis.left, yAxis.top, xAxis.right - xAxis.left, high);

      ctx.fillStyle = '#16B464';
      ctx.fillRect(xAxis.left, high, xAxis.right - xAxis.left, low);

      ctx.fillStyle = '#5100FF';
      ctx.fillRect(xAxis.left, low, xAxis.right - xAxis.left, zero);

      ctx.restore();
    }
  }]
});

export default function ExerciseDialogGlocoseChart(props) {
  const {
    bldsugr_graph_list = [],
  } = props;
  const ref = React.useRef();
  const rect = useRect(ref);
  const canvasRef = React.useRef();
  const chartRef = React.useRef();

  const hash = React.useMemo(() => {
    const data = {
      values: [],
      max: 0,
    };
    bldsugr_graph_list.forEach(item => {
      data.values.push(item?.bld_sugr_value);
      if (data.max < item?.bld_sugr_value) data.max = item?.bld_sugr_value || 0;
    });
    return data;
  }, [bldsugr_graph_list]);

  React.useEffect(() => {
    const chart = new Chart(canvasRef.current, config(hash));
    chartRef.current = chart;
    return () => {
      chart.destroy();
      delete chart.config;
    };
  }, [hash]);
  React.useLayoutEffect(() => {
    if (!chartRef.current) return;
    const frameId = requestAnimationFrame(() => {
      chartRef.current.update();
    });
    return () => {
      cancelAnimationFrame(frameId);
    };
  }, [rect]);

  return (
    <div {...ex(['Chart', 'ExerciseDialogGlocoseChart'], { ref })}>
      <canvas
        {...{
          ref: canvasRef,
          width: rect.width,
          height: rect.height,
        }}
      />
    </div>
  );
}
